'use strict';

var _ = require('lodash');
var SummaryMarketCabinSposOptGroupTransformerFactory = function SummaryMarketCabinSposOptGroupTransformerFactory(DataTransformer, momentService, $filter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function SummaryMarketCabinSposOptGroupTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['rom-summary-mode', 'rom-summary-reference-mode'];
    this.targetType = ['summary-chart', 'cabin-thematic-chart', 'day-of-week-thematic-chart', 'days-to-departure-thematic-chart', 'res-type-thematic-chart', 'point-of-sale-thematic-chart', 'kpi-ribbon', 'kpi-ribbon-reference'];
  }
  SummaryMarketCabinSposOptGroupTransformer.prototype = Object.create(DataTransformer.prototype);
  SummaryMarketCabinSposOptGroupTransformer.constructor = SummaryMarketCabinSposOptGroupTransformer;
  SummaryMarketCabinSposOptGroupTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  SummaryMarketCabinSposOptGroupTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType + '-' + metrics.join('-');
  };
  SummaryMarketCabinSposOptGroupTransformer.prototype.isCacheable = function () {
    return true;
  };
  SummaryMarketCabinSposOptGroupTransformer.prototype.transform = function (data) {
    var results = data.domain.results;
    results.sort(function (a, b) {
      return a.optGroupWeek.replace(/-/g, '') - b.optGroupWeek.replace(/-/g, '');
    });
    for (var index = 0, resultsLength = results.length; index < resultsLength; index++) {
      var week = results[index];
      if (week.processed) {
        continue;
      }
      week.romTimeBucket = week.romTimeBucket - 1;
      week.optGroupWeekMoment = memoizedMomentObject(week.optGroupWeek, momentService.FIELD.OPT_GROUP_DATE);
      week.optWeek = memoizedOptWeek(week.optGroupWeekMoment);
      week.optWeekDateMoment = memoizedMomentObject(week.optGroupWeek, momentService.FIELD.OPT_GROUP_DATE);
      week.entity = undefined;
      var weekObject = {};
      for (var dow = 0, weekLength = week.week.length; dow < weekLength; dow++) {
        var day = week.week[dow];
        day.actualRevenue = {
          individual: day.idvResType.actualScenario.revenue,
          group: day.groupResType.actualScenario.revenue
        };
        day.maxRevenue = {
          individual: day.idvResType.maxRevenueScenario.revenue,
          group: day.groupResType.maxRevenueScenario.revenue
        };
        day.minRevenue = {
          individual: day.idvResType.minRevenueScenario.revenue,
          group: day.groupResType.minRevenueScenario.revenue
        };
        day.revenueGap = {
          individual: day.idvResType.maxRevenueScenario.revenue - day.idvResType.actualScenario.revenue,
          group: day.groupResType.maxRevenueScenario.revenue - day.groupResType.actualScenario.revenue
        };
        day.maxSpillRevenue = {
          individual: day.idvResType.maxRevenueScenario.spillRevenue,
          group: day.groupResType.maxRevenueScenario.spillRevenue
        };
        day.actualSpillRevenue = {
          individual: day.idvResType.actualScenario.spillRevenue,
          group: day.groupResType.actualScenario.spillRevenue
        };
        day.spillRevenueGap = {
          individual: day.idvResType.actualScenario.spillRevenue - day.idvResType.maxRevenueScenario.spillRevenue,
          group: day.groupResType.actualScenario.spillRevenue - day.groupResType.maxRevenueScenario.spillRevenue
        };
        day.maxRecaptureRevenue = {
          individual: day.idvResType.maxRevenueScenario.recaptureRevenue,
          group: day.groupResType.maxRevenueScenario.recaptureRevenue
        };
        day.actualRecaptureRevenue = {
          individual: day.idvResType.actualScenario.recaptureRevenue,
          group: day.groupResType.actualScenario.recaptureRevenue
        };
        day.recaptureRevenueGap = {
          individual: day.idvResType.maxRevenueScenario.recaptureRevenue - day.idvResType.actualScenario.recaptureRevenue,
          group: day.groupResType.maxRevenueScenario.recaptureRevenue - day.groupResType.actualScenario.recaptureRevenue
        };
        day.fcDemand = {
          individual: day.idvResType.actualScenario.fcDemand,
          group: day.groupResType.actualScenario.fcDemand
        };
        day.actualSale = {
          individual: day.idvResType.actualScenario.sale,
          group: day.groupResType.actualScenario.sale
        };
        day.maxSale = {
          individual: day.idvResType.maxRevenueScenario.sale,
          group: day.groupResType.maxRevenueScenario.sale
        };
        day.maxRecapture = {
          individual: day.idvResType.maxRevenueScenario.recapture,
          group: day.groupResType.maxRevenueScenario.recapture
        };
        day.actualRecapture = {
          individual: day.idvResType.actualScenario.recapture,
          group: day.groupResType.actualScenario.recapture
        };
        day.maxSpill = {
          individual: day.idvResType.maxRevenueScenario.spill,
          group: day.groupResType.maxRevenueScenario.spill
        };
        day.actualSpill = {
          individual: day.idvResType.actualScenario.spill,
          group: day.groupResType.actualScenario.spill
        };
        day.saleGap = {
          individual: day.idvResType.maxRevenueScenario.sale - day.idvResType.actualScenario.sale,
          group: day.groupResType.maxRevenueScenario.sale - day.groupResType.actualScenario.sale
        };
        day.spillGap = {
          individual: day.idvResType.actualScenario.spill - day.idvResType.maxRevenueScenario.spill,
          group: day.groupResType.actualScenario.spill - day.groupResType.maxRevenueScenario.spill
        };
        day.recapGap = {
          individual: day.idvResType.maxRevenueScenario.recapture - day.idvResType.actualScenario.recapture,
          group: day.groupResType.maxRevenueScenario.recapture - day.groupResType.actualScenario.recapture
        };
        day.actualOpenPct = {
          individual: day.idvResType.actualScenario.openPercent,
          group: day.groupResType.actualScenario.openPercent
        };
        day.maxOpenPct = {
          individual: day.idvResType.maxRevenueScenario.openPercent,
          group: day.groupResType.maxRevenueScenario.openPercent
        };
        day.hostShare = {
          individual: day.idvResType.actualScenario.hostShare,
          group: day.groupResType.actualScenario.hostShare
        };
        var optGroupDateMoment = memoizedMomentObject(day.optGroupDate, momentService.FIELD.OPT_GROUP_DATE);
        day.dow = memoizedDOW(optGroupDateMoment);
        day.fullDow = memoizedFullDOW(optGroupDateMoment);
        day.optGroupWeek = week.optGroupWeek;
        day.groupResType = undefined;
        day.idvResType = undefined;
        weekObject[day.dow.toUpperCase()] = day;
      }
      week.week = weekObject;
      week.processed = true;
      results[index] = week;
    }
    return results;
  };
  var memoizedMomentObject = _.memoize(function (date, field, format) {
    return momentService.of(date, field, format);
  });
  var memoizedFormatter = function memoizedFormatter(format) {
    return _.memoize(function (moment) {
      return rmMomentFormat(moment, format);
    }, function (moment) {
      return moment.valueOf();
    });
  };
  var memoizedDOW = memoizedFormatter('DAY_OF_WEEK');
  var memoizedFullDOW = memoizedFormatter('FULL_DAY_OF_WEEK');
  var memoizedOptWeek = memoizedFormatter('MONTH_DAY');
  return SummaryMarketCabinSposOptGroupTransformer;
};
SummaryMarketCabinSposOptGroupTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', '$filter'];
module.exports = SummaryMarketCabinSposOptGroupTransformerFactory;